<template>
  <div :id="randomId + 'pdfload'">
    <input
      type="file"
      multiple="multiple"
      ref="file"
      v-on:change="handleFileUpload"
      accept="image/*, .jpg, .jpeg, .png, .pdf"
      style="display: none"
    >
    <slot v-if="!invisible">
      <BaseButton
        v-if="fullButton"
        :text="localStorage.translations.pages['setting-personal_area'].buttons['zagruzit']"
        default_icon="button-upload"
        @click="$refs.file.click()"
      >
        <IconFileFormat slot="append" jpg png pdf class="ml-3"/>
      </BaseButton>
      <v-btn text icon v-else-if="minButton" @click="onStart" height="46" :disabled="disabled" color="#277FAF">
        <IconsButton icon="button-upload" color="currentColor"/>
      </v-btn>
      <BaseButton
        v-else
        icon_only round
        :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
        :padding="$vuetify.breakpoint.smAndDown ? 10 : 15"
        default_icon="button-upload"
        @click="onStart"
        :disabled="disabled"
      />
    </slot>
    <v-dialog v-if="dialog" v-model="dialog" fullscreen scrollable transition="dialog-bottom-transition">
      <v-card color="#2e3133" tile>
        <div class="d-flex main_block">
          <v-btn
            @click="nav = !nav"
            absolute top right icon
            class="nav_btn"
            :class="nav ? '' : 'nav_btn__hidden'"
          >
            <div style="background-color: white">
              <v-icon x-large color="#277faf">mdi-arrow-left-box</v-icon>
            </div>
          </v-btn>
          <div class="nav" :class="nav ? '' : 'nav__hidden'">
            <PdfDocumentCreateNav
              :items="list"
              :file-name="fileNameEdit"
              :page-size="pageSize"
              :page-orientation="pageOrientation"
              :on-update-field="updateData"
              :on-update-position="updateDataPosition"
              :on-update-image="updateDataImage"
              :key="key"
            >
              <div class="text-center">
                <BaseButton
                  icon_only round size="60"
                  default_icon="button-upload"
                  @click="addItem" class="mb-4"
                />
              </div>
            </PdfDocumentCreateNav>
          </div>
          <div class="content pa-5 flex-grow-1">
            <PdfDocumentCreateShow
              :static-pdf="staticPdf"
              :items="list"
              :page-size="pageSize"
              :page-sizes="pageSizes"
              :page-orientation="pageOrientation"
              :file-name="fileNameEdit"
              :key="key"
              ref="pdf_show"
              :upload-function="uploadFunction"
              :indents="indents"
            />
          </div>
        </div>
        <div class="fixedBtn mr-3">
          <BaseButton
            icon_only round size="60"
            default_icon="button-save"
            :disabled="!pdfReady"
            @click="downloadDocument"
          />
          <BaseButton
            icon_only round size="60"
            default_icon="button-back"
            @click="closeDialog"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {PDFDocument} from 'pdf-lib'
import IconFileFormat from "components/icons/IconFileFormat"
import {mapActions, mapGetters, mapMutations} from "vuex"
import IconsButton from "components/icons/button/IconsButton"
import PdfDocumentCreateShow from "components/pdf/pdfDocument/PdfDocumentCreateShow";
import PdfDocumentCreateNav from "components/pdf/pdfDocument/PdfDocumentCreateNav";

const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
    reader.readAsArrayBuffer(file)
  })
}
const getNumPages = async (file) => {
  const arrayBuffer = await readFile(file)
  const pdf = await PDFDocument.load(arrayBuffer)
  return pdf.getPages()
}


export default {
  name: "PdfDocumentCreate",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    PdfDocumentCreateNav, PdfDocumentCreateShow,
    IconsButton,
    IconFileFormat,
  },
  props: {
    fileName: {
      type: [Boolean, String],
      default: 'optional name'
    },
    openFunction: {},
    uploadFunction: {},
    minButton: Boolean,
    fullButton: Boolean,
    disabled: Boolean,
    indents: Boolean,
    items: {
      type: Array,
      default: null
    },
    invisible: Boolean,
    staticPdf: {
      type: Object,
      default: () => {
        return {
          headerData: [],
          contentData: null,
          pageMargins: [15, 50, 15, 30],
          images: [],
          columnGap: 1,
        }
      }
    },
  },
  computed: {
    ...mapGetters(['apiDomain']),
    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'map_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    pdfReady() {
      let result = 0
      if (this.$refs.pdf_show) {
        result = this.$refs.pdf_show.toPrint.length
      }
      return result > 0
    },
  },
  data: () => ({
    list: [],
    key: 1,
    dialog: false,
    pageSizeList: [
      '4A0', '2A0', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10',
      'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10',
      'C0', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10',
      'RA0', 'RA1', 'RA2', 'RA3', 'RA4',
      'SRA0', 'SRA1', 'SRA2', 'SRA3', 'SRA4',
      'EXECUTIVE', 'FOLIO', 'LEGAL', 'LETTER', 'TABLOID'
    ],
    pageSize: 'A4',
    pageSizes: {
      '4A0': [4767.87, 6740.79],
      '2A0': [3370.39, 4767.87],
      A0: [2383.94, 3370.39],
      A1: [1683.78, 2383.94],
      A2: [1190.55, 1683.78],
      A3: [841.89, 1190.55],
      A4: [595.28, 841.89],
      A5: [419.53, 595.28],
      A6: [297.64, 419.53],
      A7: [209.76, 297.64],
      A8: [147.4, 209.76],
      A9: [104.88, 147.4],
      A10: [73.7, 104.88],
      B0: [2834.65, 4008.19],
      B1: [2004.09, 2834.65],
      B2: [1417.32, 2004.09],
      B3: [1000.63, 1417.32],
      B4: [708.66, 1000.63],
      B5: [498.9, 708.66],
      B6: [354.33, 498.9],
      B7: [249.45, 354.33],
      B8: [175.75, 249.45],
      B9: [124.72, 175.75],
      B10: [87.87, 124.72],
      C0: [2599.37, 3676.54],
      C1: [1836.85, 2599.37],
      C2: [1298.27, 1836.85],
      C3: [918.43, 1298.27],
      C4: [649.13, 918.43],
      C5: [459.21, 649.13],
      C6: [323.15, 459.21],
      C7: [229.61, 323.15],
      C8: [161.57, 229.61],
      C9: [113.39, 161.57],
      C10: [79.37, 113.39],
      RA0: [2437.8, 3458.27],
      RA1: [1729.13, 2437.8],
      RA2: [1218.9, 1729.13],
      RA3: [864.57, 1218.9],
      RA4: [609.45, 864.57],
      SRA0: [2551.18, 3628.35],
      SRA1: [1814.17, 2551.18],
      SRA2: [1275.59, 1814.17],
      SRA3: [907.09, 1275.59],
      SRA4: [637.8, 907.09],
      EXECUTIVE: [521.86, 756.0],
      FOLIO: [612.0, 936.0],
      LEGAL: [612.0, 1008.0],
      LETTER: [612.0, 792.0],
      TABLOID: [792.0, 1224.0],
    },
    pageOrientation: 'portrait',
    nav: true,
    errors: 0,
    fileNameEdit: '',
  }),
  created() {
    this.fileNameEdit = this.fileName
  },
  methods: {
    ...mapActions(['uploadFile']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    async onStart() {
      if (this.items) {
        this.setLoadingAnimationFullPage(true)
        this.list = []
        this.dialog = true
        for (let i in this.items) {
          if (this.items[i].text) {
            this.items[i].breakpage = Number(i) !== 0
          } else {
            let url = this.items[i].image || this.items[i].doc
            if (url) {
              try {
                let temp = await fetch(this.apiDomain + '/' + url)
                  .then(r => r.blob())
                let type = this.items[i].image ? this.items[i].image.split('.')[1] : this.items[i].doc.split('.')[1]
                let file = new File(
                  [temp], "file",
                  {type: type === 'pdf' ? 'application/pdf' : 'image/' + type}
                )
                this.items[i].file = file
                let item = await this.transformItem(file)
                this.items[i].data = item.data
                if (item.pages) this.items[i].pages = item.pages
                else {
                  this.items[i].size = 90
                  this.items[i].breakpage = false
                }
              } catch (err) {
                this.errors++
              }
            }
          }
        }
        this.list = this.items
        this.setLoadingAnimationFullPage(false)
      } else this.$refs.file.click()
    },

    async transformItem(file) {
      if (file.type === 'application/pdf' || file.type === '') {
        let numPages = await getNumPages(file)
        return {data: await this.callFileReader(file), pages: numPages.length}
      } else {
        return {data: await this.callFileReader(file)}
      }
    },

    updateData(field, value, id) {
      if (id) {
        this.list[id][field] = value
      } else {
        this[field] = value
      }
      this.key++
    },

    updateDataPosition(pos, id) {
      let elem = this.list.splice(id, 1)
      switch (pos) {
        case 'up':
          this.list.splice(id - 1, 0, elem[0])
          break
        case 'down':
          this.list.splice(id + 1, 0, elem[0])
          break
        case 'delete':
          this.list.splice(id, 1)
          break
      }
      this.key++
    },

    updateDataImage(id, value) {
      this.list[id].data = value
      this.key++
    },

    closeDialog() {
      this.$refs.file.value = null
      this.dialog = false
      this.list = []
    },

    addItem() {
      this.$refs.file.value = null
      this.$refs.file.click()
    },

    handleFileUpload(e) {
      if (this.dialog === false && this.openFunction) this.openFunction()
      this.dialog = true
      let temp = e.target.files
      this.transformFiles(temp)
    },

    async transformFiles(temp) {
      for (let i in temp) {
        if (typeof temp[i] === 'object') {
          let item = await this.transformItem(temp[i])
          if (this.fileNameEdit === 'optional name')
            this.fileNameEdit = temp[i].name
          let itm = {
            file: temp[i],
            data: item.data
          }
          if (item.pages) {
            itm.pages = item.pages
            itm.doc = true
          } else {
            itm.size = 'contain'
            itm.breakpage = false
            itm.imageUpload = true
          }
          this.list.push(itm)
          this.key++
        }
      }
    },

    callFileReader(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (event) => {
          resolve(event.target.result)
        }
      })
    },

    async downloadDocument() {
      if (this.$refs.pdf_show) this.$refs.pdf_show.downloadDocument()
      this.$refs.file.value = null
      if (this.uploadFunction) this.closeDialog()
    },
  }
}
</script>

<style scoped lang="scss">
.nav {
  height: calc(100vh - 60px);
  width: 320px;
  padding: 32px 12px;
  background-color: white;
  box-shadow: 0 0 10px 5px rgba(black, 0.1);
  overflow-y: auto;
  overflow-x: visible;
  z-index: 2;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
  transition-property: all;

  &__hidden {
    margin-left: -320px;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    position: fixed;
    top: 60px;
    left: 0;
    box-shadow: 0 0 10px 0 rgba(black, 0.2);
  }

  .d-flex:hover {
    :deep() .v-card {
      background-color: #f2f2f2 !important;
    }
  }

  :deep() .minimize {
    .v-input__control {
      .v-input__slot {
        background-color: #f2f2f2 !important;
      }
    }
  }

  :deep() .v-card {
    background-color: #f2f2f2 !important;
  }

  :deep() .inp_container {
    *, *:before, *:after {
      border: none !important;
    }
  }
}

.content {
  height: calc(100vh - 60px);
  overflow-y: auto;
}


.nav_btn {
  z-index: 3;
  top: 10px;
  left: 270px;

  &__hidden {
    left: 10px;
    transform: rotateZ(180deg);
  }
}

.main_block {
  max-width: 100vw;
  max-height: calc(100vh - 60px);
}
</style>